import "./rightbar.css";
import Online from "../online/Online";

import { OnlineUsers } from "../../dummyData";

export default function Rightbar({profile}) {
  const HomeRightbar = () => {
    return (
      <>
        <div className="birthdayContainer">
          <img src="assets/gift.png" alt="" className="birthdayImg" />
          <span className="birthdayText"><b>Gary Collins</b> and <b>2 other friends</b> have a birthday today</span>
        </div>
        <img src="assets/ad.jpg" alt="" className="rightbarAd" />
        <h4 className="rightbarTitle">Online Friends</h4>
        <ul className="rightbarFriendList">
          {OnlineUsers.map((u) => (
            <Online key={u.id} user={u} />
          ))}
        </ul>
      </>
    );
  };

  const ProfileRightbar = () => {
    return (
    <>
      <div className="rightbarProfileInfo">
        <h4 className="rightbarTitle">User information</h4>
        <div className="rightbarInfo">
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">City:</span>
            <span className="rightbarInfoValue">New York</span>
          </div>
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">From:</span>
            <span className="rightbarInfoValue">Madrid</span>
          </div>
          <div className="rightbarInfoItem">
            <span className="rightbarInfoKey">Relationship:</span>
            <span className="rightbarInfoValue">Single</span>
          </div>
        </div>
      </div>
      <div className="rightbarProfileFriends">
      <h4 className="rightbarTitle">User friends</h4>
      <div className="rightbarFollowings">
        <div className="rightbarFollowing">
          <img src="assets/person/human_8.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Kristen Parker</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_18.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">James Cooper</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_2.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Janell Shrum</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_3.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Alex Durden</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_6.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Donna Lewis</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_9.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Gary Collins</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_1.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">George Kocaoglu</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_10.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Safak Simpson</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_20.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Joy Marshall</span>
        </div>
        <div className="rightbarFollowing">
          <img src="assets/person/human_5.jpg" alt="" className="rightbarFollowingImg" />
          <span className="rightbarFollowingName">Thomas Holden</span>
        </div>
      </div>
      </div>
      <div className="rightbarProfileOnline">
        <h4 className="rightbarTitle">Online Friends</h4>
        <ul className="rightbarFriendList">
          {OnlineUsers.map((u) => (
            <Online key={u.id} user={u} />
          ))}
        </ul>
      </div>
    </>
    );
  };

  return (
    <div className="rightbar">
      <div className="rightbarWrapper">
        {profile ? <ProfileRightbar /> : <HomeRightbar />}
      </div>
    </div>
  );
}
